import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=3fd986b0&scoped=true&lang=html&"
import script from "./signup.vue?vue&type=script&lang=js&"
export * from "./signup.vue?vue&type=script&lang=js&"
import style0 from "./signup.vue?vue&type=style&index=0&id=3fd986b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd986b0",
  null
  
)

export default component.exports